import { render, staticRenderFns } from "./BasketballCover_c3.vue?vue&type=template&id=8b985f16&"
import script from "./BasketballCover_c3.vue?vue&type=script&lang=js&"
export * from "./BasketballCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports